import { LottieCartType } from "@cart-client/hooks/useCommonCartheaderLottie/constants";

export interface LottieFrameData {
    initial: number;
    final: number;
    transitionFrame?: number;
}

export interface StampFrameData {
    initial: number;
    final: number;
}
export enum LottieType {
    STAMP = "STAMP",
    MAIN = "MAIN",
}

type FrameData = {
    type: LottieType.STAMP | LottieType.MAIN;
    data: {
        initial: number;
        final: number;
        transitionFrame?: number;
    };
};

export const getFrameData = (cartType: string, type: FrameData["type"]): LottieFrameData | undefined => {
    const frameConfigs: Record<string, Record<FrameData["type"], LottieFrameData>> = {
        [LottieCartType._99STORE]: {
            MAIN: { initial: 2, final: 250, transitionFrame: 60 },
            STAMP: { initial: 80, final: 479 },
        },
        [LottieCartType.EO_CART]: {
            MAIN: { initial: 2, final: 250, transitionFrame: 60 },
            STAMP: { initial: 80, final: 479 },
        },
        [LottieCartType.BOLT]: {
            MAIN: { initial: 0, final: 0, transitionFrame: 0 },
            STAMP: { initial: 0, final: 0 },
        },
        [LottieCartType.EXPRESS]: {
            MAIN: { initial: 0, final: 0, transitionFrame: 0 },
            STAMP: { initial: 0, final: 0 },
        },
        [LottieCartType.BLACKOTG]: {
            MAIN: { initial: 0, final: 0, transitionFrame: 0 },
            STAMP: { initial: 0, final: 0 },
        },
        [LottieCartType.TOING]: {
            MAIN: { initial: 0, final: 0, transitionFrame: 0 },
            STAMP: { initial: 0, final: 66 },
        },
    };

    return frameConfigs[cartType]?.[type];
};
